import { uid } from 'uid';

class ModalDialog {

    constructor() {
        this.dialog = document.createElement('dialog');
        const theDialog = this.dialog;
        this.dialog.addEventListener('click', (event) => {
            if (event.target == theDialog)
            {
                theDialog.close();
            }
        });

        this.divContainer = document.createElement('div');

        this.divContent = document.createElement('div');

        this.dialog.appendChild(this.divContainer);
        this.dialog.appendChild(this.divContent);

        document.body.appendChild(this.dialog);
        
    }

    open(contentElements) {
        if (contentElements !== undefined) { this.divContent.replaceChildren(contentElements);}
        this.dialog.showModal(); 
    }

    close() {
        this.dialog.close();
    }
}

class RandomColor {
    static RGBArray() {
        var num = Math.round(0xffffff * Math.random());
        return [
            num >> 16,
            num >> 8 & 255,
            num & 255
        ];

    }

    static toRGBAArray(rbgaStr) {
        const rgbaArray = rbgaStr.match(/\d+/g).map(Number);
        if (rgbaArray.length < 4) { rgbaArray.push(1); }
        return rgbaArray;

    }
    static ToRGBArray(rgbaStr) {
        const rgba = this.toRGBAArray(rgbaStr);
        return rgba.slice(0, 3);
    }

    static RGBA(alpha = 0.4) {
        const rbg = this.RGBArray();
        return `rgba(${rbg[0]}, ${rbg[1]}, ${rbg[2]}, ${alpha})`
    }
}

class Cookie{
    static set(name, value) {
        document.cookie = `${name}=${value}`;
    }
    static get(name) {
        return document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${name}=`))
        ?.split("=")[1];
    }
}

class Table {
    constructor(id, numberOfColumns) {
        this.id;
        if (!document.getElementById(id)) {
            throw new Error(`Div ${id} does not exist`);
        }
        this.tableElement = document.getElementById(id);
        this.numCols = numberOfColumns;
    }

    clear() { this.tableElement.replaceChildren(); }

    addHeader(headerNames) {
        if (headerNames.length != this.numCols) {
            throw new Error("Unexpected th count");
        }
        const tr = document.createElement('tr');
        headerNames.map((element, index) => {
            const th = document.createElement('th');
            th.innerHTML = element;
            tr.appendChild(th);
        });
        this.tableElement.appendChild(tr);
    }

    createDataRow(elements) {
        if (elements.length != this.numCols) {
            throw new Error("Unexpected row count");
        }
        const tr = document.createElement('tr');
        elements.map((element) => tr.appendChild(element));
        return tr;
    }
    //overwrite this function
    addRows(data) {
        rows = [];
        data.foreach((item) => {
            let elements = [];
            for (let [key, value] of Object.entries(item)) {
                elements.push(this.createTD_Text(value));
            }
            const row = createDataRow(elements);
            table.appendChild(row);
        });
    }

    createTD_auto(value, changelistener) {
        switch (typeof value) {
            case 'string':
            case 'number':
                return this.createTD_text(value);
            case 'boolean':
                return this.createTD_checkbox(value, changelistener);
            default:
                throw new Error("Cannot create TD automatically.");
        }
    }

    createTD_text(text) {
        const td = document.createElement('td');
        td.innerHTML = text;
        return td;
    }
    createTD_checkbox(isChecked, changeFunction) {
        const td = document.createElement('td');
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.checked = isChecked;
        if (changeFunction) {
            input.addEventListener('change', changeFunction);
        }
        td.appendChild(input);
        return td;
    }
}

function callJsonApi(url, type, inputData, outputDataHandler, resultHandler, dialogText, useToken=false) {
    if (!url) { throw new Error("define url"); }
    if (!type) { type = 'get'; }
    if (!outputDataHandler) { outputDataHandler =  function (results) { return results; } }
    if (!resultHandler) { resultHandler =  function (results) { return results; } }
    let loadingDiv;
    function validateResult(results)
    {
        if (results.statusCode != 200) 
        {
            throw new Error(results.error.description)
        }
        return results;
    }
    const headers = new Headers(
        {
            'content-type': 'application/json' 
        }
    )
    if (useToken) {
        const token = localStorage.getItem('token');
        if (!token)
        {
            alert("Please log on.");
            return;
        }
        const bearer = 'Bearer ' + token;
        headers.append('Authorization', bearer);
    }
    if (dialogText) {
        loadingDiv = document.createElement('dialog');
        const p = document.createElement('p');
        p.innerHTML = dialogText;
        loadingDiv.appendChild(p);
        document.body.appendChild(loadingDiv);
        loadingDiv.showModal();
    }
    var requestInit = {
        method: type,
        headers: headers,
    };
    const queryURL = new URL(url);
    switch (type) {
        case 'post':
        case 'put':
            if (!inputData) { throw new Error("No data to send"); }
            requestInit.body = JSON.stringify(inputData);
            break;
        case 'get':
        case 'delete':
            if (inputData) {
                for (let [key, value] of Object.entries(inputData)) {
                    queryURL.searchParams.append(key, value);
                    }
            }
            break;
        default:
            throw new Error("Unknown request type.");
    }
    fetch(queryURL.href, requestInit)
        .then((response) => response.json())
        .then((results) => validateResult(results))
        .then((results) => outputDataHandler(results))
        .then((results) => resultHandler(results))
        .catch((e) => alert("Error: " + e.message))
        .then(() => { if (dialogText) { document.body.removeChild(loadingDiv); } })
}

class CheckboxList {
    constructor(parentID, items, changeActionCallback, infoClickCallBack, createNested=true) {
        this.items = items;
        this.parentID = parentID;
        this.parentElement = document.getElementById(parentID);
        this.changeActionCallback = changeActionCallback;
        this.infoClickCallBack = infoClickCallBack;
    }

    static CreateItemsArray(itemsName, nameValuePairs, checkboxListName, selectAll = true) {
        let items = { checkboxListName: checkboxListName };
        items.name = itemsName;
        items.checkboxList = nameValuePairs.map((nvp) =>
        ( {
            name: nvp.name,
            value: (nvp.value) ? nvp.value : uid(),
            isChecked: selectAll,
            children: null,
        }));
        return items
    }

    addLi(item, parentUl, level) {
        const li = document.createElement('li');
        parentUl.appendChild(li);

        if (item.children == null) {
            const infoButton = document.createElement('label');
            infoButton.innerHTML ='&#9432;';
            infoButton.addEventListener('click', (e) => {
                if (this.infoClickCallBack) {
                    this.infoClickCallBack(e, item);
                }
            });
            li.appendChild(infoButton);

            const label = document.createElement('label');
            label.innerText = item.name;

            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.checked = item.isChecked;
            //        checkbox.name = this.items.checkboxListName;
            checkbox.value = item.value;
            item.theCheckbox = checkbox;
            checkbox.addEventListener('change', (e) => {
                item.isChecked = e.currentTarget.checked;
                if (this.changeActionCallback) {
                    this.changeActionCallback(e, item);
                }
            });
            label.appendChild(checkbox);
            li.appendChild(label);

            return;
        }

        
        const italics = document.createElement('i');
        italics.innerHTML = '+ ' + item.name;

        const childUl = document.createElement('ul');
        const id = uid();
        childUl.id = id;
        childUl.style.display = 'none';

        li.appendChild(italics);
        li.appendChild(childUl);

        li.appendChild(italics);
        li.appendChild(childUl);

        italics.addEventListener('click', (e) => {
            if (e.currentTarget.innerHTML[0] === '+') {
                document.getElementById(id).style.display = 'block';
                e.currentTarget.innerHTML = e.currentTarget.innerHTML.replace('+', '-');
            }
            else {
                document.getElementById(id).style.display = 'none';
                e.currentTarget.innerHTML = e.currentTarget.innerHTML.replace('-', '+');
            }
        });
        if (level < 2) {
            italics.click();
        }

        level++;
        item.children.forEach((child) => this.addLi(child, childUl, level))
    }

    createCheckBoxList(name = null) {
        this.parentElement.replaceChildren();

        if (name != null) {
            const h4 = document.createElement('h4');
            h4.innerHTML = name;
            this.parentElement.appendChild(h4);
        }
        let level = 0
        const parentUl = document.createElement('ul');
        parentUl.style.marginRight = 'auto';
        this.parentElement.appendChild(parentUl);
        this.items.forEach((item) => {
                this.addLi(item, parentUl, level);
        });
    }


}

function createRangeInputDual(rangeItem, labelText, changeCallBack) {
    rangeItem.range.sort((a, b) => a - b);
    rangeItem.values.sort((a, b) => a - b);
    const label = document.createElement('label');
    const nameGuid = uid();
    label.htmlFor = nameGuid;
    const input1 = document.createElement('input');
    const input2 = document.createElement('input');
    label.innerText = `${labelText}: `;
    const rangeLabel = document.createElement('label');
    rangeLabel.innerText = `[${rangeItem.values[0]} | ${rangeItem.values[1]}]`;
    rangeLabel.id = uid();
    input1.name = input2.name = nameGuid;
    input1.type = input2.type = 'number';
    input1.min = input2.min = rangeItem.range[0];
    input1.max = input2.max = rangeItem.range[1];
        
    input1.step = input2.step = (rangeItem.step == null) ? 0.01 :  rangeItem.step;
    input1.value = rangeItem.values[0];
    input2.value = rangeItem.values[1];
    input1.addEventListener('change', (e) => {
        rangeItem.values[0] = parseFloat(e.currentTarget.value);
        rangeItem.values.sort((a, b) => a - b);
        rangeLabel.innerText = `[${rangeItem.values[0]} | ${rangeItem.values[1]}]`;
        if (changeCallBack) { changeCallBack.update(rangeItem); }
    });
    input2.addEventListener('change', (e) => {
        rangeItem.values[1] = parseFloat(e.currentTarget.value);
        rangeItem.values.sort((a, b) => a - b);
        rangeLabel.innerText = `[${rangeItem.values[0]} | ${rangeItem.values[1]}]`;
        if (changeCallBack) { changeCallBack.update(rangeItem); }
    });
    label.appendChild(input1);
    label.appendChild(input2);
    label.appendChild(rangeLabel);
    return label;
}

class Shortcuts {
    shortcuts = {};
    constructor() {
        document.addEventListener('keydown', (e) => {
            const lowerCaseKey = e.key.toLowerCase();
            if (!Object.hasOwn(this.shortcuts, lowerCaseKey)) { return; }
            const shortcutsForKey = this.shortcuts[lowerCaseKey];
            shortcutsForKey.forEach((shortcut) => {
                if (shortcut.isOverElement) {
                    shortcut.callback(e);
                }
            });
        });
    }

    addShortcut(key, callback, elementId) {
        let shortcut = {
            key: key.toLowerCase(),
            callback: callback,
            isOverElement: true,
        };
        if (elementId) {
            shortcut.elementId = elementId;
            shortcut.isOverElement = false;
            const el = document.getElementById(elementId);
            if (!el) {
                throw new Error(elementId + ' does not exist');
            }
            el.addEventListener('mouseenter', e =>
                shortcut.isOverElement = true);
            el.addEventListener('mouseleave', e =>
                shortcut.isOverElement = false);
        }
        if (!Object.hasOwn(this.shortcuts, key)) {
            this.shortcuts[key] = [shortcut];
        }
        else {
            this.shortcuts[key].push(shortcut);
        }
    }
}
export { ModalDialog, RandomColor, Table, CheckboxList, 
    createRangeInputDual, callJsonApi, Shortcuts,
    Cookie };
